<template>
  <v-btn style="height: 43px; width: 190px"
         @click="clickConnect"
         :loading="connectButtonLoading || connecting"
         >
    <v-xero-connect-blue-btn
      v-if="hover"
      class="align-center cursor-pointer"
      @mouseover="hover = true"
      @mouseleave="hover= false">
    </v-xero-connect-blue-btn>
    <v-xero-connect-white-btn
      v-else
      class="align-center cursor-pointer"
      @mouseover="hover = true"
      @mouseleave="hover= false">
    </v-xero-connect-white-btn>
  </v-btn>
</template>

<script>

import XeroMixin from '../../mixins/xeroMixin';
import firebase from 'firebase';
import API from '@/api';
import VXeroConnectBlueBtn from './XeroConnectBlue.vue';
import VXeroConnectWhiteBtn from './XeroConnectWhite.vue';

// https://developer.xero.com/documentation/guides/how-to-guides/branding-your-integration/

export default {
  name: 'VXeroDirectConnectBtn',
  components: {
    VXeroConnectWhiteBtn,
    VXeroConnectBlueBtn,
  },
  props: {
    connecting: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
  },
  mixins: [
    XeroMixin,
  ],
  data() {
    return {
      hover: false,
      connectButtonLoading: false,
    };
  },
  methods: {
    async clickConnect() {

      this.connectButtonLoading = true;
      this.$emit('connecting');

      const basePath = `message_list/${this.companyId}`;
      const apiResponse = await API.xero.initiate({ companyId: this.companyId });
      const dbRef = firebase.database();
      const newMessageRef = dbRef.ref(basePath).push();
      newMessageRef.set({
        refresh: false,
      });

      localStorage.setItem('XeroMessagePath', newMessageRef.key);

      this.refDbKey = dbRef.ref(`${basePath}/${newMessageRef.key}`);
      this.refDbKey.on('value', this.onDbUpdate);

      window.open(apiResponse.data.url, 'Xero Auth', 'width=500,height=500,toolbar=0,menubar=0');
    },
    async onDbUpdate(snapshot) {
      const v = snapshot.val();
      if (v.refresh) {
        this.connectButtonLoading = false;
        this.cleanDbRef();

        await this.$store.dispatch('companies/getProfileCompany', { id: this.companyId });
        this.loadCompanyXeroInfo(this.companyId);

        this.$emit('connected');
      }
    },
    async cleanDbRef() {
      if (this.refDbKey) {
        this.refDbKey.off('value', this.onDbUpdate);
        await this.refDbKey.remove();

        // const dbRef = firebase.database().ref(`message_list/${this.companyId}`);
        // dbRef.remove();

        this.refDbKey = null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/xero/XeroDirectConnectButton.vue